import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Modal from '../../Modal/Modal';

import StepByStep from '../../StepByStep';
import PayStorageFeeByCard from './PayStorageFeeByCard';
import Status from '../Status';
import Paragraph from '../../Paragraph/Paragraph';
import { selectCreditCards } from '../../../store/selectors/creditCardSelectors';

const steps = [PayStorageFeeByCard, Status];

const PayStorageFeeByCardModal = ({
  isOpen,
  handleClose,
  storageFeeAmount,
  setStorageFeeAmount,
  isAutoPaySettingsModalOpen,
  setIsAutoPaySettingsModalOpen,
  setIsOpenPayStorageFeeByCard,
  isOpenPayStorageFeeByCard,
  handleRefreshTransactions,
}) => {
  const { t } = useTranslation();
  const [error, setError] = useState('');
  const [selectedCreditCard, setSelectedCreditCard] = useState();
  const creditCards = useSelector(selectCreditCards);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [isAutoPayOn, setIsAutoPayOn] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    setIsAutoPayOn(creditCards?.some((card) => card.IsDefaultForStorage));
    setSelectedCreditCard(
      creditCards?.find((card) => card.IsDefaultForStorage) || creditCards[0],
    );
  }, [creditCards]);

  useEffect(() => {
    setButtonDisabled(!creditCards?.some((card) => card.IsDefaultForStorage));
  }, [creditCards]);

  useEffect(() => {
    if (error) {
      const payStorageFeeErrorCode = error?.response?.data?.Errors[0]?.Code;
      const payStorageFeeErrorMessage =
        error?.response?.data?.Errors[0]?.Message;

      const payStorageFeeErrorMessageText =
        payStorageFeeErrorCode === 'BraintreeTransactionError'
          ? payStorageFeeErrorMessage
          : t('storageFee.payStorageFeeByCardModal.paymentFailureMessage');

      setErrorMessage(payStorageFeeErrorMessageText);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  if (!isOpen) {
    return null;
  }

  return (
    <>
      <Modal
        isOpen={isOpen}
        close={handleClose}
        title={t('storageFee.payStorageFeeByCardModal.label')}
        size="sm"
        closeIconVisible
      >
        <StepByStep saveStepDisabled>
          {({ goStepForward, goStepBack }) =>
            steps.map((step) =>
              React.createElement(step, {
                handleBack: goStepBack,
                handleNext: goStepForward,
                handleClose,
                setError,
                hasError: !!error,
                text: (
                  <>
                    <Paragraph bold marginBottom={12}>
                      {error
                        ? t(
                            'storageFee.payStorageFeeByCardModal.paymentFailureTitle',
                          )
                        : t(
                            'storageFee.payStorageFeeByCardModal.paymentSuccessfulTitle',
                          )}
                    </Paragraph>
                    {error
                      ? errorMessage
                      : t(
                          'storageFee.payStorageFeeByCardModal.paymentSuccessfulMessage',
                        )}
                  </>
                ),
                backButtonText: t('common.ok'),
                onButtonClick: handleClose,
                storageFeeAmount,
                setStorageFeeAmount,
                setSelectedCreditCard,
                selectedCreditCard,
                showAutoPayStatus: true,
                isAutoPayOn,
                setIsAutoPayOn,
                isAutoPaySettingsModalOpen,
                setIsAutoPaySettingsModalOpen,
                setIsOpenPayStorageFeeByCard,
                isOpenPayStorageFeeByCard,
                buttonDisabled,
                handleRefreshTransactions,
              }),
            )
          }
        </StepByStep>
      </Modal>
    </>
  );
};

PayStorageFeeByCardModal.propTypes = {
  isOpen: PropTypes.bool,
  handleClose: PropTypes.func,
  storageFeeAmount: PropTypes.number,
  setStorageFeeAmount: PropTypes.func,
  isAutoPaySettingsModalOpen: PropTypes.bool,
  setIsAutoPaySettingsModalOpen: PropTypes.func,
  setIsOpenPayStorageFeeByCard: PropTypes.func,
  isOpenPayStorageFeeByCard: PropTypes.bool,
  handleRefreshTransactions: PropTypes.func,
};

export default PayStorageFeeByCardModal;
